import { PureComponent, type ReactNode } from 'react';
import ChevronButton from '../ChevronButton';

interface BrandButtonProps {
  children: ReactNode;
}

export default class BrandButton extends PureComponent<BrandButtonProps> {
  render() {
    const { children, ...props } = this.props;

    return (
      <ChevronButton bsStyle="primary" {...props}>
        {children}
      </ChevronButton>
    );
  }
}
